import axios from 'axios';
import Config from '../constants/config';


class AxiosDataService {
//  Commented below code because envc is fetched from CER
//  getCookie = (cname) => {
//   var name = cname + "=";
//   var decodedCookie = decodeURIComponent(document.cookie);
//   var ca = decodedCookie.split(';');
//   for(var i = 0; i <ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) === ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) === 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return "";
// }

  fetch(obj) {
    // let envAppData;
    // let envcFlag;
    // var envccookieData =  this.getCookie('envc');
    // if (envccookieData === null || envccookieData === "") { 
    //   envcFlag = false;
    // }else{
    //   envcFlag = true;
    // }
    // if(envcFlag) {
    //   //const envcActualData = localStorage.getItem("envc");
    //   const envcActualData = envccookieData;
    //   const envcApiCall = envcActualData.replace("-app-","-api-");
    //   if(obj.flag==="app")
    //   {
    //     envAppData = "?envc="+envcActualData;
    //   }else{
    //     envAppData = "?envc="+envcApiCall;
    //   }
    // }else{
    //   envAppData = "";
    // }

    let urlApp;
    if (obj.flag === "app") {
      urlApp = obj.url;
    } else {
      urlApp = Config.Backend_URL + obj.url;
    }
    
    const options = {
      url: urlApp,
      method: obj.method,
      headers: obj.headers || null,
      data: obj.data || null,
      cache: false,
      timeout: obj.timeout,
    }
     return axios(options);
    };
     
  }
  export default new AxiosDataService();